import './pagination.scss';
import Sloth from '../Sloth';



/** WEBPACK FOOTER **
 ** ./components/Pagination/pagination.js
 **/